import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import ModuleInMap from './ModuleInMap';
import SideEventLogs from './event/SideEventLogs';
import StatusLegend from './legend/StatusLegend';

import { StatusMapContainer, SideMapContainer } from './StatusComponentMap.css.js';
import map from 'static/images/map/map_png.png';

const StatusComponentMap = (props) => {
  const cancellationToken = useCancellationToken();
  const [areaDatas, setAreaDatas] = useState(null);
  const gasLog = useSelector((store) => store.gasLog);
  const criterion = useSelector((store) => store.criterion);
  const settings = useSelector((store) => store.settings);

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    if (gasLog.status === 'SUCCESS') {
      setAreaDatas([...gasLog.gas]);
    }
  }, [criterion, settings, gasLog]);

  useEffect(() => () => cancellationToken.cancel(), []);

  if (!areaDatas) {
    return (
      <StatusMapContainer>
        <img src={map} alt="map" />
      </StatusMapContainer>
    );
  }

  return (
    <>
      <StatusMapContainer>
        {areaDatas.map((data) => {
          return <ModuleInMap key={`${data.title}_${data.moduleIdx}`} audio={props.audio} {...data} />;
        })}
        <img src={map} alt="map" />
      </StatusMapContainer>
      <StatusLegend />
      <SideMapContainer>
        <SideEventLogs />
      </SideMapContainer>
    </>
  );
};

export default StatusComponentMap;
